import $ from "jquery";

const onboarding = () => {
  const init = () => {
    steps();
  };

  const steps = () => {
    const el = {
      steps: ".js-onboarding-steps",
      step: ".js-onboarding-step",
    };

    if ($(el.steps).length === 0) return;

    const progress = Number($(el.steps).data("progress"));
    $(el.step).each(function () {
      const _progress = Number($(this).data("progress"));
      if (_progress === progress) {
        $(this).addClass("Current");
      } else if (_progress < progress) {
        $(this).addClass("Active");
      }
    });
  };
  init();
};

try {
  onboarding();
} catch (error) {
  console.error("onboarding", error);
}
